// extracted by mini-css-extract-plugin
export default {"pageContainer":"unauthorised_pageContainer__QazEq"};